import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "./axios";
import { useSelector } from "react-redux";
import { startGlobalLoader, stopGlobalLoader } from "../Loader";

export const isAuthenticated = () => {
  let token = localStorage.getItem("access_token");
  if (!token || token === "") {
    return false;
  } else {
    return true;
  }
};
export const showMessage = (msg, type) => {
  if (type === "success") {
    toast.success(msg, {
      position: "top-right",
    });
  } else if (type === "error") {
    toast.error(msg, {
      position: "top-right",
    });
  } else {
    toast.info(msg, {
      position: "top-right",
    });
  }
};
export const callAPI = (method, endpoint, data) => {
  let errors;

  let tkn = localStorage.getItem("access_token")
    ? localStorage.getItem("access_token")
      ? localStorage.getItem("access_token")
      : localStorage.getItem("artisan_token")
    : localStorage.getItem("access_token")
    ? localStorage.getItem("access_token")
    : localStorage.getItem("artisan_token");

  // axios.defaults.headers.common["Authorization"] = tkn ?  "Bearer " + tkn : ''

  if (tkn) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + tkn;
  }
  // axios.defaults.headers.common['Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  startGlobalLoader();
  if (method === "post") {
    return axios
      .post(endpoint, data)
      .then((res) => {
        if (res.data.status) {
          if (res.data.message !== "") {
            showMessage(`${res.data.message}`, "success");
            stopGlobalLoader();
          }
          stopGlobalLoader();
          return res.data.data;
        } else {
          const errors = res.data.errors;

          if (Array.isArray(errors)) {
            errors.forEach((error) => {
              showMessage(error, "error");
              stopGlobalLoader();
            });
          } else if (typeof errors === "object") {
            Object.keys(errors).forEach((key) => {
              showMessage(`${errors[key]}`, "error");
              stopGlobalLoader();
            });
          } else if (typeof errors === "string") {
            showMessage(errors, "error");
            stopGlobalLoader();
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 400) {
          errors = err.response.data.errors;
          if (typeof errors === "object") {
            Object.keys(errors).map(function (key, index) {
              stopGlobalLoader();
              showMessage(`${errors[key]}`, "error");
            });
          } else if (typeof errors === "string") {
            stopGlobalLoader();
            showMessage(errors, "error");
          }
        } else if (err.response.status === 401) {
          stopGlobalLoader();
          showMessage("Access denied.", "error");
          window.location.href = "/";
        } else if (err.response.status === 404) {
          stopGlobalLoader();
          showMessage("API request not found", "error");
        } else {
          stopGlobalLoader();
          showMessage(err.message, "error");
          //window.location.href = '/';
        }
        stopGlobalLoader();
      });
        stopGlobalLoader();

  }
  if (method === "get") {
    return axios
      .get(endpoint)
      .then((res) => {
        if (res.data.status) {
          if (res.data.message !== "") {
            stopGlobalLoader();
            showMessage(`${res.data.message}`, "success");
          }
          if (res.data.hasOwnProperty("pagination")) {
            stopGlobalLoader();
            let res_data = {
              data: res.data.data,
              pagination: res.data.pagination,
            };
            return res_data;
          } else {
            stopGlobalLoader();
            return res.data.data;
          }
        } else {
          stopGlobalLoader();
          errors = res.data.errors;
          console.log(res.data);

          Object.keys(errors).map(function (key, index) {
            showMessage(`${errors[key]}`, "error");
          });
        }
        stopGlobalLoader();
        //
      })
      .catch((err) => {
        if (err.response.status === 400) {
          errors = err.response.data.errors;
          if (Object.keys(err.response.data.data).length !== 0) {
            Object.keys(errors).map(function (key, index) {
              stopGlobalLoader();
              showMessage(`${errors[key]}`, "error");
            });
          }
        } else if (err.response.status === 401) {
          stopGlobalLoader();
          showMessage("Access denied.", "error");
          localStorage.removeItem("access_token");
          window.location.href = "/";
        } else if (err.response.status === 404) {
          stopGlobalLoader();
          showMessage("API request not found", "error");
        } else {
          stopGlobalLoader();
          showMessage(err.message, "error");
          //window.location.href = "/";
        }
        stopGlobalLoader();
      });
  }
  if (method === "delete") {
    return axios
      .delete(endpoint, data)
      .then((res) => {
        if (res.data.status) {
          if (res.data.message !== "") {
            stopGlobalLoader();
            showMessage(`${res.data.message}`, "success");
          }
          return res.data.data;
        } else {
          stopGlobalLoader();
          errors = res.data.errors;
          Object.keys(errors).map(function (key, index) {
            showMessage(`${errors[key]}`, "error");
          });
        }
        stopGlobalLoader();
      })
      .catch((err) => {
        if (err.response.status === 400) {
          stopGlobalLoader();
          errors = err.response.data.errors;
          Object.keys(errors).map(function (key, index) {
            stopGlobalLoader();
            showMessage(`${errors[key]}`, "error");
          });
        } else if (err.response.status === 401) {
          stopGlobalLoader();
          showMessage("Access denied.", "error");
          window.location.href = "/";
        } else if (err.response.status === 404) {
          stopGlobalLoader();
          showMessage("API request not found", "error");
        } else {
          stopGlobalLoader();
          showMessage(err.message, "error");
          //window.location.href = '/';
        }
      });
  }
};

export const hasPermission = (primaryMenuRes, module, permission) => {
  const userPermissions = primaryMenuRes?.find(
    (item) => item.module === module
  )?.permissions;
  return userPermissions?.includes(permission) ?? false;
};

export const numberFormat = (number, decimal) => {
  decimal = decimal ?? 2;
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  }).format(parseFloat(number));
};

export const formatAmount = (amount) => {
  if (typeof amount !== "number") {
    amount = parseFloat(amount);
    if (isNaN(amount)) return "0.00";
  }
  return amount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 4,
  });
};
